import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SiteService } from '@sla-ng/core';
import { Observable } from 'rxjs';
import { ISlairUser } from '../models/slair-user.model';

@Injectable({
    providedIn: 'root',
})
export class BffResource {


    constructor(
        protected myHttpClient: HttpClient,
        private mySiteService: SiteService,
    ) {
    }


    public getSelf(): Observable<ISlairUser> {
        const bffApi: string = this.mySiteService.getConfigKey('bff_api');
        return this.myHttpClient.get<ISlairUser>(`${bffApi}/user-info`, { withCredentials: true });
    }

    public login(): void {
        window.location.href = this.mySiteService.getConfigKey('bff_login');
    }

    public logout(): void {
        window.location.href = this.mySiteService.getConfigKey('bff_logout');
    }

}
